module.exports = __webpack_public_path__ + "static/media/bridge.4b44a369.svg";